import { Tag, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getStatusTagConfig } from '../../../ReviewEntriesStatusCell/utils/getStatusTagConfig'
import * as Styled from './styles'

interface ReviewEntryDetailTitleProps {
  status?: string
  title: string
}

export const ReviewEntryDetailTitle = ({ status, title }: ReviewEntryDetailTitleProps): ReactElement => {
  const { t } = useTranslation()

  const statusTag = getStatusTagConfig(status, {
    processing: t('review_entries.status.processing'),
    toValidate: t('review_entries.status.to_validate'),
    validated: t('review_entries.status.validated'),
    written: t('review_entries.status.written'),
  })

  return (
    <Styled.ReviewEntryDetailTitleRow>
      <Styled.ReviewEntryDetailTitleText>
        <Text title={title} truncate variant="h2">
          {title}
        </Text>
      </Styled.ReviewEntryDetailTitleText>
      <Styled.ReviewEntryDetailStatusTag>
        <Tag color={statusTag.color} icon={statusTag.icon} size="sm" type="subtle">
          {statusTag.label}
        </Tag>
      </Styled.ReviewEntryDetailStatusTag>
    </Styled.ReviewEntryDetailTitleRow>
  )
}
